const devices = {
  small_mobile: `(min-width: 320px)`,
  mobile: `(min-width: 375px)`,
  tablet: `(min-width: 768px)`,
  laptop: `(min-width: 1024px)`,
  desktop: `(min-width: 2560px)`
};

export default devices